// 🎊 SYSTÈME DE CONFETTIS & CÉLÉBRATIONS
import confetti from 'canvas-confetti';

/**
 * Lance une explosion de confettis classique
 */
export function fireConfetti() {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 }
  });
}

/**
 * Confettis de bienvenue (première connexion du jour)
 */
export function welcomeConfetti() {
  const duration = 3 * 1000;
  const animationEnd = Date.now() + duration;
  const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  const interval = setInterval(function() {
    const timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    const particleCount = 50 * (timeLeft / duration);
    
    // Confettis des deux côtés
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
      colors: ['#a855f7', '#ec4899', '#06b6d4', '#fbbf24', '#22c55e']
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      colors: ['#a855f7', '#ec4899', '#06b6d4', '#fbbf24', '#22c55e']
    });
  }, 250);
}

/**
 * Confettis de victoire (gagné au jeu)
 */
export function victoryConfetti() {
  const count = 200;
  const defaults = { origin: { y: 0.7 }, zIndex: 9999 };

  function fire(particleRatio, opts) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio)
    });
  }

  fire(0.25, { spread: 26, startVelocity: 55, colors: ['#FFD700', '#FFA500'] });
  fire(0.2, { spread: 60, colors: ['#FFD700', '#FFA500'] });
  fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8, colors: ['#a855f7', '#ec4899'] });
  fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2, colors: ['#22c55e', '#06b6d4'] });
  fire(0.1, { spread: 120, startVelocity: 45, colors: ['#FFD700', '#ec4899'] });
}

/**
 * Confettis de tampon obtenu
 */
export function stampConfetti() {
  confetti({
    particleCount: 50,
    spread: 60,
    origin: { y: 0.8 },
    colors: ['#a855f7', '#ec4899', '#FFD700'],
    zIndex: 9999
  });
}

/**
 * Confettis niveau atteint (VIP, Gold, etc.)
 */
export function levelUpConfetti() {
  // Étoiles qui montent
  const defaults = { spread: 360, ticks: 100, gravity: 0, decay: 0.94, startVelocity: 30, zIndex: 9999 };

  function shoot() {
    confetti({
      ...defaults,
      particleCount: 30,
      scalar: 1.2,
      shapes: ['star'],
      colors: ['#FFD700', '#FFA500', '#FF6B6B']
    });

    confetti({
      ...defaults,
      particleCount: 20,
      scalar: 0.75,
      shapes: ['circle'],
      colors: ['#a855f7', '#ec4899', '#06b6d4']
    });
  }

  setTimeout(shoot, 0);
  setTimeout(shoot, 100);
  setTimeout(shoot, 200);
}

/**
 * Confettis anniversaire
 */
export function birthdayConfetti() {
  const duration = 5 * 1000;
  const animationEnd = Date.now() + duration;
  const colors = ['#ff69b4', '#ff1493', '#da70d6', '#ba55d3', '#9370db', '#8a2be2'];

  (function frame() {
    confetti({
      particleCount: 3,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
      colors: colors,
      zIndex: 9999
    });
    confetti({
      particleCount: 3,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
      colors: colors,
      zIndex: 9999
    });

    if (Date.now() < animationEnd) {
      requestAnimationFrame(frame);
    }
  }());
}

/**
 * 🏅 Confettis de badge débloqué
 * Explosion spéciale avec la couleur du badge
 */
export function launchBadgeConfetti(badgeColor = '#a855f7') {
  // Explosion principale avec la couleur du badge
  confetti({
    particleCount: 80,
    spread: 100,
    origin: { y: 0.6 },
    colors: [badgeColor, '#FFD700', '#ffffff'],
    zIndex: 9999,
    scalar: 1.2,
  });

  // Étoiles dorées
  setTimeout(() => {
    confetti({
      particleCount: 30,
      spread: 360,
      origin: { y: 0.5 },
      shapes: ['star'],
      colors: ['#FFD700', '#FFA500'],
      scalar: 1.5,
      zIndex: 9999,
      gravity: 0.5,
    });
  }, 200);

  // Pluie latérale
  setTimeout(() => {
    confetti({
      particleCount: 40,
      angle: 60,
      spread: 45,
      origin: { x: 0 },
      colors: [badgeColor, '#ec4899'],
      zIndex: 9999,
    });
    confetti({
      particleCount: 40,
      angle: 120,
      spread: 45,
      origin: { x: 1 },
      colors: [badgeColor, '#ec4899'],
      zIndex: 9999,
    });
  }, 400);
}

/**
 * 🎊 Lance des confettis personnalisés
 * @param {Object} options - Options de confetti
 */
export function launchConfetti(options = {}) {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    zIndex: 9999,
    ...options,
  });
}

/**
 * 💜 Confettis de match Heartbeats
 */
export function matchConfetti() {
  const colors = ['#ec4899', '#a855f7', '#8b5cf6', '#f472b6', '#c084fc'];
  
  // Cœurs qui tombent des deux côtés
  confetti({
    particleCount: 60,
    angle: 60,
    spread: 55,
    origin: { x: 0 },
    colors: colors,
    shapes: ['circle'],
    scalar: 1.2,
    zIndex: 9999,
  });
  
  confetti({
    particleCount: 60,
    angle: 120,
    spread: 55,
    origin: { x: 1 },
    colors: colors,
    shapes: ['circle'],
    scalar: 1.2,
    zIndex: 9999,
  });

  // Explosion centrale
  setTimeout(() => {
    confetti({
      particleCount: 100,
      spread: 100,
      origin: { y: 0.5, x: 0.5 },
      colors: colors,
      zIndex: 9999,
    });
  }, 300);
}

export default {
  fireConfetti,
  welcomeConfetti,
  victoryConfetti,
  stampConfetti,
  levelUpConfetti,
  birthdayConfetti,
  launchBadgeConfetti,
  launchConfetti,
  matchConfetti,
};
